<div
	(click)="$event.stopPropagation()"
	*ngrxLet="filterOptions$ as filterOptions"
	class="classification-filter-container visible-scroll colored-scroll-track nice-scroll"
>
	<div [class.visibility-hidden]="!filterOptions" class="options-container">
		<mat-form-field class="classification-type m-b-sxs" color="primary">
			<mat-label>{{ 'classification_standard' | translate }}</mat-label>
			<mat-select
				(selectionChange)="selectedClassificationType$.next($event.value)"
				[value]="selectedClassificationType$ | async"
				panelClass="nice-scroll visible-scroll colored-scroll-track"
			>
				@for (option of classificationTypes; track option) {
					<mat-option [value]="option.id">
						{{ option.name | translate }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<au-search-input
			(searchTextChanged)="searchText$.next($event)"
			class="m-b-sxs classification-search"
			placeholder="{{ 'search' | translate }}"
			#searchInput
		></au-search-input>
		<div class="classification-options nice-scroll visible-scroll colored-scroll-track">
			<classification-tree-component
				[expandAll]="searchInput.formControl.value.length > 1"
				[data]="filterOptions"
			>
				<ng-template let-node let-treeControl="treeControl">
					<mat-checkbox
						(change)="toggleCheck(node, treeControl, $event)"
						[checked]="descendantsAllSelected(node, treeControl)"
						[indeterminate]="descendantsPartiallySelected(node, treeControl)"
						class="au-checkbox"
						color="primary"
					>
						{{ node.name }}
					</mat-checkbox>
				</ng-template>
			</classification-tree-component>

			@if (!filterOptions?.length) {
				<div class="no-results">
					@if ((searchText$ | async).length) {
						<div class="no-data p-l-sm m-t-sxs m-b-sxs">
							{{ 'no_results' | translate }}
						</div>
					} @else {
						<div class="no-data flex-center-center p-l-sm m-t-sxs m-b-sxs">
							<mat-spinner diameter="40"></mat-spinner>
						</div>
					}
				</div>
			}
		</div>
	</div>
</div>
